import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { Loading } from "components/panels";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import React from "react";
import { useElementHeight, useViewport } from "utilities/hookutils";

export interface TableWithHeaderBaseProps {
  title: string
  pagination: React.ReactNode
  exportButton: React.ReactNode
  isLoading: boolean
  items: any[]
  itemsClassName?: string
  children: React.ReactNode
  selectionEnabled: boolean
  showingOnlyMySelection?: boolean
  selectionCount?: number
  selectedOnThisPage?: number
  toggleAll?: () => void
  hideTopPaginationOnMobile?: boolean
  hideBottomPagination?: boolean
  hideNoDataAvailableDiv?: boolean
  layoutButtons?: React.ReactNode
}

const TableWithHeaderBase = (props: TableWithHeaderBaseProps) => {
  const {
    title,
    pagination,
    exportButton,
    isLoading,
    items,
    itemsClassName = "",
    children,
    selectionEnabled,
    selectionCount,
    selectedOnThisPage,
    showingOnlyMySelection,
    toggleAll,
    hideTopPaginationOnMobile,
    hideBottomPagination,
    hideNoDataAvailableDiv,
    layoutButtons
  } = props;

  const heightHelper = useElementHeight();
  const viewport = useViewport();

  const hideTopPagination = viewport === "mobile" && hideTopPaginationOnMobile;
  const hideMySelectionCheckbox = !selectionEnabled || showingOnlyMySelection || (items.length === 0 && !isLoading);
  const hideExportButton = (items.length === 0 && !isLoading) || !exportButton;
  const hideToggleLayoutButton = (items.length === 0 && !isLoading) || !layoutButtons;

  return <>
    {(title || pagination) && <PanelSegmentType>
      <PanelSegmentType.Header size="h2">
        {!hideMySelectionCheckbox && <div className="selectiontool-myselection-checkall-checkbox"><Checkbox
          checked={selectedOnThisPage !== 0}
          onChange={toggleAll}
        /></div>}
        <PanelSegmentType.Title title={showingOnlyMySelection ? `${RESX.GeneralLabels.MySelection} : ${selectionCount}` : title} />
        {!hideTopPagination && <PanelSegmentType.Pagination>{pagination}</PanelSegmentType.Pagination>}
        {!hideToggleLayoutButton && layoutButtons}
        {!hideExportButton && exportButton}
      </PanelSegmentType.Header>
    </PanelSegmentType>}

    {isLoading && <Loading height={heightHelper.height} dontAlignCenter />}
    {!isLoading && items.length === 0 && !hideNoDataAvailableDiv && <NoDataAvailableDiv />}

    {items.length > 0 && <div className={itemsClassName} ref={heightHelper.ref}>{children}</div>}

    {!hideBottomPagination && pagination && <div className="flex justify-end">
      {pagination}
    </div>}
  </>;
};

export default TableWithHeaderBase;